import { getSsWidget } from 'utils/sdk'

export const DEFAULT_LOCALE = 'en'

export const configLang = {
	lang: getSsWidget().options.lang,
}
